import Vue from "vue";

class PublisherAdvertisementService {

    constructor() {
        this.trafficType = {
            active: 1,
            deactive: 0,
            all: [0,1],
        }
    }

    /**
     * Get traffic types list
     * @param {{ status: number, per_page: number, get_nested_children: boolean, only_child: boolean }} query 
     */
    async getList(query = {
        status: 1,
        get_nested_children: false,
        only_child: false,
    }) {
        try {
            return await Vue.axios.get("/traffic-types", {
                params: query,
            });
        } catch(e) {
            return Promise.reject(e);
        }
    }

    async getAdvertises(query = { page: 1, per_page: 10, lang: "vi", status: this.trafficType.all }) {
        if(!query.status) {
            query = { ...query, status: this.trafficType.all.join(",") };
        }

        try {
            return await Vue.axios.get("/publisher-advertisements", {
                params: query
            });
        } catch(e) {
            return Promise.reject(e);
        }
    }

    /**
     * 
     * @param {{  description: string, traffic_type: string, children_traffic_type: string, url:  string, images: Array<File> }} data 
     */
    async create(data = {}) {
        try {
            const formData = new FormData();

            for(let key in data) {
                if(key === "images") {
                    const files = data[key];
                    files.forEach((file) => {
                        formData.append("images[]", file, file.name);
                    });
                }
                else {
                    formData.append(key, data[key]);
                }
            }

            return await Vue.axios.post("/publisher-advertisements/store", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            })
        } catch(e) {
            return Promise.reject(e);
        }
    }
    
    /**
     * Create new advertises multiple items
     * @param {Array<{  description: string, traffic_type: string, children_traffic_type: string, url:  string, images: Array<File> }>} data The data list to create
     */
    async createMultiple(data = []) {
        try {
            return await Vue.axios.post("/publisher-advertisements/multiple-store", data);
        } catch(e) {
            return Promise.reject(e);
        }
    }
}

const publisherAdvertisementService = new PublisherAdvertisementService();

export default publisherAdvertisementService;


// WEBPACK FOOTER //
// ./src/core/services/publisherAdvertisementService.js